import '../_prototypes/parsley';

$('[name="email"]').focus();
